import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=e5a328dc"
import script from "./modal.vue?vue&type=script&lang=js"
export * from "./modal.vue?vue&type=script&lang=js"
import style0 from "./modal.vue?vue&type=style&index=0&id=e5a328dc&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports